<div
  class="modal-header"
  i18n="@@new-project"
>Neues Projekt</div>

<div class="modal-body">
  <div class="row mb-1">
    <div class="col-3">
      <span i18n="@@name-label">Name:</span>
    </div>
    <div class="col">
      <input
        pInputText
        pSize="small"
        type="text"
        class="w-100"
        [(ngModel)]="this.project.name"
      >
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <span i18n="@@description-label">Beschreibung:</span>
    </div>
    <div class="col">
      <textarea
        pInputTextarea
        class="w-100"
        rows="3"
        [(ngModel)]="this.project.description"
      ></textarea>
    </div>
  </div>
  <h5>
    <span i18n="@@access-control-workmode">Zusammenarbeit</span>
  </h5>
  <div
    class="row align-items-center mt-3"
    style="margin-bottom: 10px;"
  >
    <div class="col-3">
      <span i18n="@@edit-in-org">Bearbeitbar von:</span>
    </div>
    <div class="col">
      <p-select
        [options]="editModeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.project.editMode"
      ></p-select>
    </div>
  </div>
  <div class="row align-items-center mt3">
    <div class="col-3">
      <span i18n="@@share-in-org">Teilen mit:</span>
      <app-hint i18n="@@hint-share-in-org">Macht den Bot für alle Mitglieder der ausgewählten Organisation
        sichtbar und nutzbar</app-hint>
    </div>
    <div class="col">
      <p-select
        [options]="orgShareOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.project.orgShort"
      ></p-select>
    </div>
  </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Speichern"
    i18n-label="@@save"
    (onClick)="this.addProject()"
  ></p-button>
</div>